import {
  Box,
  ModalProps,
  SimpleGrid,
  useTimeout,
  VStack,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import SimplePopup from "components/SimplePopup";
import { useMemo, useState } from "react";
import ConfettiExplosion from "@reonomy/react-confetti-explosion";
import RefreshCountdown from "components/RefreshCountdown";
import V1Card from "components/V1Card";
import pluralize from "pluralize";
import { v2Name } from "config";

type MintSuccessPopupProps = Omit<ModalProps, "children"> & {
  tokenIds: number[];
  onSuccess: () => void;
};

const MintSuccessPopup = ({
  tokenIds,
  onSuccess,
  ...rest
}: MintSuccessPopupProps) => {
  const translate = useTranslate();
  const [isReady, setIsReady] = useState(false);

  useTimeout(() => setIsReady(true), 1000);

  const celebration = useMemo(
    () =>
      isReady ? (
        <Box position="absolute" left="50%" top="4rem">
          <ConfettiExplosion
            floorWidth={700}
            floorHeight={1000}
            particleCount={70}
          />
        </Box>
      ) : null,
    [isReady]
  );

  return (
    <SimplePopup
      title={translate("mint:success:title")}
      isClosable={false}
      description={
        tokenIds.length > 1
          ? translate("mint:success:description:multi", {
              v2Name: pluralize(v2Name, tokenIds.length),
            })
          : translate("mint:success:description", {
              tokenId: tokenIds[0],
              v2Name: pluralize(v2Name, tokenIds.length),
            })
      }
      size="md"
      scrollBehavior="inside"
      {...rest}
    >
      {celebration}

      <VStack pt="5" spacing="6">
        <SimpleGrid
          columns={tokenIds.length > 1 ? 2 : 1}
          spacing="3"
          w="full"
          borderRadius="lg"
        >
          {tokenIds.map((tokenId) => (
            <V1Card key={tokenId} p="0" tokenId={tokenId} withV2Badge />
          ))}
        </SimpleGrid>

        <RefreshCountdown />
      </VStack>
    </SimplePopup>
  );
};

export default MintSuccessPopup;
